export default ({ name = 'current' }: { name?: MaybeRef<string> } = {}) => {
  const query = useQueryPriceList.byName({ name })

  const dataWithoutUpgrades = computed(() => ({
    ...query.data.value,
    items: query.data.value?.items.filter(({ data: { upgrade_only } }) => !upgrade_only) ?? [],
  }))

  return {
    dataWithoutUpgrades,
    ...query,
  }
}
